import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NbDialogRef } from '@nebular/theme';
import { ToastrService } from 'ngx-toastr';
import { SevaProfileService } from 'src/app/Service/seva-profile.service';

@Component({
  selector: 'app-confirm-forward-to-gao-modal',
  templateUrl: './confirm-forward-to-gao-modal.component.html',
  styleUrls: ['./confirm-forward-to-gao-modal.component.scss']
})
export class ConfirmForwardToGAOModalComponent {

  public data: any;
  endPoint: any;
  payload: any;
  forwardForm!: FormGroup;
  submitted = false;

  constructor(
    private toastr: ToastrService,
    private fb: FormBuilder,
    private api: SevaProfileService,
    protected dialogRef: NbDialogRef<ConfirmForwardToGAOModalComponent>
  ) {
    this.data = this.dialogRef;
  }

  ngOnInit() {
    this.endPoint = this.data.endPoint;
    this.payload = this.data.requestBody;
    this.initializeForm();
  }

  initializeForm() {
    this.forwardForm = this.fb.group({
      comment: ['', [Validators.required]],
    });
  }

  forwardToGAO() {
    if (this.forwardForm.invalid) {
      this.submitted = true;
      this.forwardForm.markAllAsTouched();
      return;
    }

    this.submitted = false;
    const comment = this.forwardForm.get('comment')?.value;
    this.payload.Comment = comment;

    this.api.apiCall(this.endPoint, 'POST', this.payload).subscribe({
      next: (response: any) => {
        if (response.Data) {
          this.toastr.success('Application forwarded to GAO successfully');
          this.dialogRef.close(true);
        }
      },
      error: (error) => {
        console.error('API Error:', error);
        this.toastr.error(error.error?.Message || 'Failed to forward application');
        this.dialogRef.close(false);
      }
    });
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
